var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "-1 -6 20 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5833 11.75L14.25 11.75L14.25 3.41667C14.25 3.18646 14.0635 3 13.8333 3L12.1667 3C11.9365 3 11.75 3.18646 11.75 3.41667L11.75 11.75L3.41667 11.75C3.18646 11.75 3 11.9365 3 12.1667L3 13.8333C3 14.0635 3.18646 14.25 3.41667 14.25L11.75 14.25L11.75 22.5833C11.75 22.8135 11.9365 23 12.1667 23L13.8333 23C14.0635 23 14.25 22.8135 14.25 22.5833L14.25 14.25L22.5833 14.25C22.8135 14.25 23 14.0635 23 13.8333L23 12.1667C23 11.9365 22.8135 11.75 22.5833 11.75Z",
    id: "Icon-Color",
    fill: "current",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a816d253684cd6114c2aedad8978b753.svg";
export { ForwardRef as ReactComponent };